import React from 'react';
import { Building, User, Clock, TrendingUp, Shield, Zap, Lightbulb, DollarSign } from 'lucide-react';
const BenefitsSection = () => {
  const companyBenefits = [{
    icon: <TrendingUp className="h-10 w-10 text-[#0EA5E9]" />,
    title: "Increased Productivity",
    description: "Optimize workflows by automating repetitive tasks with AI agents"
  }, {
    icon: <DollarSign className="h-10 w-10 text-[#0EA5E9]" />,
    title: "Cost Efficiency",
    description: "Reduce long-term operational costs through systematic automation"
  }, {
    icon: <Shield className="h-10 w-10 text-[#0EA5E9]" />,
    title: "Quality Assurance",
    description: "Maintain consistency and reduce human error in standard processes"
  }, {
    icon: <Clock className="h-10 w-10 text-[#0EA5E9]" />,
    title: "Faster Time-to-Market",
    description: "Accelerate project delivery with AI handling routine operations"
  }];
  const talentBenefits = [{
    icon: <Lightbulb className="h-10 w-10 text-[#6366F1]" />,
    title: "Focus on Innovation",
    description: "Spend more time on creative and strategic tasks that AI can't replace"
  }, {
    icon: <Zap className="h-10 w-10 text-[#6366F1]" />,
    title: "Skill Enhancement",
    description: "Learn to work with AI and develop automation skills for future roles"
  }, {
    icon: <User className="h-10 w-10 text-[#6366F1]" />,
    title: "Career Advancement",
    description: "Become an AI trainer and workflow designer - roles in high demand"
  }, {
    icon: <Building className="h-10 w-10 text-[#6366F1]" />,
    title: "Portfolio Building",
    description: "Showcase your ability to create and maintain AI workflows"
  }];
  return <section className="py-16 bg-gradient-to-br from-white via-[#F0F9FF] to-[#E0F2FE]">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">Why Choose Talento AI</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          <div>
            <h3 className="text-2xl font-bold text-center mb-8 text-[#0EA5E9]">
              Benefits for Companies
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {companyBenefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-[#0EA5E9]/10">
                  <div className="flex justify-center mb-4">
                    {benefit.icon}
                  </div>
                  <h4 className="text-lg font-semibold text-center mb-2">{benefit.title}</h4>
                  <p className="text-gray-600 text-center">{benefit.description}</p>
                </div>)}
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-center mb-8 text-[#6366F1]">
              Benefits for Talents
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {talentBenefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-[#6366F1]/10">
                  <div className="flex justify-center mb-4">
                    {benefit.icon}
                  </div>
                  <h4 className="text-lg font-semibold text-center mb-2">{benefit.title}</h4>
                  <p className="text-gray-600 text-center">{benefit.description}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default BenefitsSection;